import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isInFilter } from "../utils/dateFilter";

/** Prefer createdAt for recency; fall back to receiptDate when backend omits createdAt */
function receiptTimeMs(r) {
    const raw = r?.createdAt ?? r?.receiptDate;
    const t = raw ? new Date(raw).getTime() : 0;
    return Number.isFinite(t) ? t : 0;
}

export default function ReceiptDashboard({ filter, url, user, token }) {
    const [receipts, setReceipts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        if (!user) return;

        async function fetchReceipts() {
            try {
                const expRes = await fetch(`${url}/receipt/${user.main_id}`, {
                    method: "GET",
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (!expRes.ok) {
                    throw new Error("Failed to load receipts");
                }

                const data = await expRes.json();
                const list = Array.isArray(data) ? data : [];
                setReceipts(list);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }

        fetchReceipts();
    }, [url, user, token]);

    const filteredReceipts = [...receipts]
        .filter((r) => isInFilter(r.createdAt ?? r.receiptDate, filter))
        .sort((a, b) => receiptTimeMs(b) - receiptTimeMs(a));

    if (loading)
        return <p className="text-center text-gray-600 py-6">Loading receipts...</p>;

    if (error)
        return <p className="text-center text-red-600 py-6">Error: {error}</p>;

    return (
        <div>
            <div className="flex justify-between gap-2 items-center mb-3">
                <h2 className="text-[20px] font-bold text-[#222] ">
                    Receipt Summary
                </h2>
                <button
                    onClick={() => navigate('/receipt')}
                    className="text-xs px-2 py-1 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-600 hover:text-white transition">
                    View more
                </button>
            </div>

            <div className="bg-gray-50 rounded p-2 min-h-[120px]">
                <table className="w-full text-sm">
                    <thead className="font-semibold text-gray-700">
                        <tr>
                            <th className="text-left py-1">Invoice #</th>
                            <th className="text-left py-1">Customer Name</th>
                            <th className="text-left py-1">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredReceipts?.length ? (
                            filteredReceipts.slice(0, 10).map((exp, idx) => (
                                <tr
                                    key={exp.id != null ? String(exp.id) : `r-${exp.invoiceNumber}-${exp.createdAt}-${idx}`}
                                    className="border-t"
                                >
                                    <td className="py-2 text-left text-gray-800">{exp.invoiceNumber || "-"}</td>
                                    <td className="py-2 text-left text-gray-800">
                                        {exp.customerName
                                            ? exp.customerName.slice(0, 15) + (exp.customerName.length > 15 ? "…" : "")
                                            : "-"}
                                    </td>

                                    <td className="py-2 text-left text-gray-800">₹{exp.amount || "-"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center py-4 text-gray-500">
                                    No receipts found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
